// Cities with hierarchical relationships and geo coordinates
export const cities = [
    {
        id: 'CITY-MUM',
        name: 'Mumbai',
        state: 'Maharashtra',
        tier: 1,
        codPreference: 0.35, // 35% prefer COD
        lat: 19.0760,
        lng: 72.8777,
        pinCodes: ['400001', '400058', '400050', '400601'],
    },
    {
        id: 'CITY-DEL',
        name: 'Delhi',
        state: 'Delhi',
        tier: 1,
        codPreference: 0.40,
        lat: 28.6139,
        lng: 77.2090,
        pinCodes: ['110001', '110017', '110075', '122001'],
    },
    {
        id: 'CITY-BLR',
        name: 'Bangalore',
        state: 'Karnataka',
        tier: 1,
        codPreference: 0.25,
        lat: 12.9716,
        lng: 77.5946,
        pinCodes: ['560034', '560038', '560066'],
    },
    {
        id: 'CITY-HYD',
        name: 'Hyderabad',
        state: 'Telangana',
        tier: 1,
        codPreference: 0.30,
        lat: 17.3850,
        lng: 78.4867,
        pinCodes: ['500034', '500081', '500032'],
    },
    {
        id: 'CITY-CHN',
        name: 'Chennai',
        state: 'Tamil Nadu',
        tier: 1,
        codPreference: 0.28,
        lat: 13.0827,
        lng: 80.2707,
        pinCodes: ['600017', '600040', '600042'],
    },
    {
        id: 'CITY-PUN',
        name: 'Pune',
        state: 'Maharashtra',
        tier: 1,
        codPreference: 0.32,
        lat: 18.5204,
        lng: 73.8567,
        pinCodes: ['411001', '411014', '411027'],
    },
    {
        id: 'CITY-KOL',
        name: 'Kolkata',
        state: 'West Bengal',
        tier: 1,
        codPreference: 0.45,
        lat: 22.5726,
        lng: 88.3639,
        pinCodes: ['700001', '700020', '700091'],
    },
    {
        id: 'CITY-AMD',
        name: 'Ahmedabad',
        state: 'Gujarat',
        tier: 1,
        codPreference: 0.38,
        lat: 23.0225,
        lng: 72.5714,
        pinCodes: ['380001', '380015', '380054'],
    },
    {
        id: '00001',
        name: 'Nagpur',
        state: 'Maharashtra',
        tier: 2,
        codPreference: 0.40,
        lat: 21.1458,
        lng: 79.0882,
        pinCodes: ['441111', '440001', '440010'],
    },
    {
        id: '00002',
        name: 'Raipur',
        state: 'Chhattisgarh',
        tier: 2,
        codPreference: 0.45,
        lat: 21.2514,
        lng: 81.6296,
        pinCodes: ['492001', '492004', '492015'],
    },
];

// Helper functions
export function getCityById(cityId) {
    return cities.find(city => city.id === cityId);
}

export function getCityName(cityId) {
    const city = getCityById(cityId);
    return city ? city.name : 'Unknown';
}

export function getCityIds() {
    return cities.map(c => c.id);
}

export function getCityByName(name) {
    return cities.find(city => city.name.toLowerCase() === name.toLowerCase());
}

export default cities;
